import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { Store } from "./Store";
import createAxiosInstance, { getToken, setAuthToken } from "../axios/axiosCustom";
import Loader from "./Loader";
import initializeStates from "./initializeStates";

const PrivateRoute = (props) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [isValid, setIsValid] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const isFetchingUser = useRef(false)
  const { children } = props
  
  const { state, dispatch} = useContext(Store)
  
  async function getRefreshToken(){
    const axiosCustom = await createAxiosInstance()

    if(!isLoading || isFetchingUser.current) return // Exit if already loading
    setIsLoading(true)

    let refreshToken = Cookies.get('refreshToken')
    try {
      if(refreshToken) {
        setIsLoading(false)
        setIsValid(true)
        
      } else {
        navigate("/")
        return
      }

      if (!isFetchingUser.current) {
        isFetchingUser.current = true

        let accToken = getToken()
        let bearerAccessToken = ''
        if(!accToken) {
          let resp = await axiosCustom.post('/token', { refreshToken: refreshToken})
          accToken = resp.data.accessToken
          bearerAccessToken = 'Bearer ' + accToken
        } else {
          bearerAccessToken = accToken
        }

        setAuthToken(bearerAccessToken)

        await initializeStates(accToken, refreshToken, dispatch, state)
        setIsValid(true)
      }
  
    } catch(err){
      console.warn(err)
      if(err.response.status == 401 || err.response.status == 403){
        navigate("/")
        return
      }
    } finally {
      setIsLoading(false)
      isFetchingUser.current = false
    }
  }
  
  useEffect(() => {
    if(pathname !== '/') getRefreshToken()    
  }, [pathname])


  return isLoading ? (
    <Loader />
  ) : isValid ? (
    children
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;